import Form from "../../components/Form";

function Register() {
  return <Form />;
}

export default Register;
